/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
import React, { FunctionComponent } from 'react';
import styles from './TruncatedString.module.css';

export interface ITruncatedStringProps {
  title?: string;
}

export const TruncatedString: FunctionComponent<ITruncatedStringProps> = ({
  title,
  children,
}) => (
  <span
    className={styles.fieldName}
    data-title={title || (typeof children === 'string' ? children : undefined)}
  >
    {children}
  </span>
);
